import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Country } from '@app/models/country';
import { CountryService } from '@app/services/shared/country.service';
import { MemberService } from '@app/services/member.service';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { Sort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { CSVDataService } from '@app/export/CSVDataService';
import { SortService } from '@app/components/sorting/SortService';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MenuItem, SelectItem, MessageService } from 'primeng/api';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { ReportService } from '../../services/Reports/Report.service';

interface District {
  id: number;
  shortName: string;
  name: string;
  seat: string;
}

interface IYear {
  year: number;
}

interface Institution {
  id: number;
  shortName: string;
  name: string;
  noOfMembers: number;
}

interface SignType {
  id: number;
  name: string;
}

interface Sign {
  id: number;
  abbreviation: string;
  name: string;
  type: number;
  sort: number;
}

interface MemberResult {
  photo: any;
  memberInfo: {
    id: number;
    givenName: string;
    otherForeNames: string;
    middleName: string;
    familyName: string;
    formerName: string;
    title: string;
    birthday: string;
    h_CareOf: string;
    h_City: string;
    h_Country: string;
    h_Street: string;
    h_ZipCode: string;
    o_CareOf: string;
    o_City: string;
    o_Country: string;
    o_Street: string;
    o_ZipCode: string;
    w_CareOf: string;
    w_City: string;
    w_Country: string;
    w_Street: string;
    w_ZipCode: string;
    phone: string;
    phone2: string;
    phoneWork: string;
    phoneMobile: string;
    fax: string;
    email1: string;
    email2: string;
    webSite: string;
    initiationDate: string;
    mentor: {
      memberId: number;
      givenName: string;
      familyName: string;
      formerName: string;
      birthday: string;
    }
    isSubscriber: boolean;
    localId: number;
  },
  primaryInstitution2: {
    id: number;
    shortName: string;
    name: string;
  }
  checked: boolean;
  institutionId: number;
  institutionShortName: string;
  institutionName: string;
  institutionVisitingCity: string;
  institutionVisitingCountry: string;
  membershipStartDate: string;
  membershipEndDate: string;
  startCause: string;
  endCause: string;

}

@Component({
  selector: 'app-medlemreport',
  templateUrl: './medlemreport.component.html',
  styleUrls: ['./medlemreport.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MedlemreportComponent implements OnInit, OnDestroy {
  memberPhoto: string | undefined;

  countries: Country[] = [];
  epost1: SelectItem[];
  epost2: SelectItem[];
  soft: SelectItem[];
  rangeValues: number[] = [1900, 2020];
  displayMembershipInstitutions = false;
  displayNoMembershipInstitutions = false;
  selectedmembers: any[] = [];
  memberform;
  
  years: IYear[] = [];
  selectedyears: any[] = [];
  memberresult: MemberResult[] = [];
  districtlist: District[] = [];
  institutionbydistrictlist: Institution[] = [];
  institutionlist: Institution[] = [];
  signtypelist: SignType[] = [];
  signlist: Sign[] = [];
  officetypelist;
  officelist;
  committeelist;
  someorall: SelectItem[];
  expanded = true;
  expandedlabel = 'Stäng grupper';
  showMailView = false;
  showLabelsAsHtml = false;
  subscriptions: Subscription[] = [];
  can_view_postals = false;
  can_send_email = false;
  /************* Dateformat ****************************************/
  // maxYear ska sättas dynamiskt.
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  membershipselectedinstitutions: any[] = [];
  nomembershipselectedinstitutions: any[] = [];
  items: MenuItem[];
  se;
  access;
  showSpinner = false;
yearstest = []
  constructor(
    private fb: FormBuilder,
    private permissionsService: PermissionsService,
    private countryService: CountryService,
    private memberService: MemberService,
    private reportService: ReportService,
    private institutionService: InstitutionsService,
    private memberofficeService: MemberofficeService,
    private datePipe: DatePipe,
    private messageService: MessageService) {
  }

  ngOnInit() {
    this.memberform = this.fb.group({
      onlyActiveMembers: [true, ''],
      memberIdFrom: ['', ''],
      memberIdTo: ['', ''],
      givenName: ['', ''],
      familyName: ['', ''],
      homeZipCode: ['', ''],
      homeCity: ['', ''],
      homeCountry: ['', ''],
      membershipCreatedFrom: ['', ''],
      membershipCreatedTo: ['', ''],
      membershipChangedFrom: ['', ''],
      membershipChangedTo: ['', ''],
      selectedYears: this.fb.control([]),
      email1Exists: ['both', ''],
      email2Exists: ['both', ''],
      isSoftSubscriber: ['both', ''],
      membershipSomeOrAll: ['', ''],
      nomembershipSomeOrAll: ['', ''],
      membershipInstitutions: [null, null],
      noMembershipInstitutions: [null, null],
      membershipStartedFrom: ['', ''],
      membershipStartedTo: ['', ''],
      membershipEndedFrom: ['', ''],
      membershipEndedTo: ['', ''],
      noMembershipStartedFrom: ['', ''],
      noMembershipStartedTo: ['', ''],
      noMembershipEndedFrom: ['', ''],
      noMembershipEndedTo: ['', ''],
      parentInstitutionId: ['', ''],
      institutionTypeId: ['', ''],
      includePhoto: [true, '']
    });
    this.permissionsService.access.subscribe(a => {
      if (a) {
        this.access = a;
      }
    });
    this.permissionsService.selectedrole.subscribe(r => {
      if (r) {
        this.setPermissions();
      }
    });
    //this.setPermissions();
    this.se = {
      firstDayOfWeek: 1,
      dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
      dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
      dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
      monthNames: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      today: 'I dag',
      clear: 'Rensa',
      dateFormat: 'yy-mm-dd',
      weekHeader: 'Vecka'
    };
   /* this.countryService.getCountries().subscribe(c => {
      this.countries = c;
    });*/
    this.countries = this.countryService.getCountryList();
    for (let i = this.rangeValues[1]; i > this.rangeValues[0] - 1; i--) {
      this.years.push({ year: i });
    }
    this.epost1 = [{ label: 'Ja', value: 'yes' }, { label: 'Nej', value: 'no' }, { label: 'Båda', value: 'both' }];
    this.epost2 = [{ label: 'Ja', value: 'yes' }, { label: 'Nej', value: 'no' }, { label: 'Båda', value: 'both' }];
    this.soft = [{ label: 'Ja', value: 'yes' }, { label: 'Nej', value: 'no' }, { label: 'Båda', value: 'both' }];
    this.someorall = [{ label: 'både', value: 'all' }, { label: 'någon av', value: 'some' }];
    this.getAllDistricts();
    this.getAllInstitutions();
    this.getSignTypes();
    this.getSigns();
    this.getOfficesTypes();
    this.getOffices();
    this.getCommittees();
    this.setItems();
  }

  setPermissions() {
    const user_permissions = JSON.parse(sessionStorage.getItem('selectedrole')).permissions;
    this.can_view_postals = user_permissions.indexOf('VIEW_POSTALS') !== -1;
    this.can_send_email = user_permissions.indexOf('SEND_EMAIL') !== -1;
    this.setItems();
    /*const userid = this.permissionsService.userid;
    let can_view_postals_observable = this.permissionsService.hasPermissionForMember('VIEW_POSTALS', userid);
    let can_send_email_observable = this.permissionsService.hasPermissionForMember('SEND_EMAIL', userid);
    this.subscriptions.push(forkJoin([
      can_view_postals_observable,
      can_send_email_observable,
    ]).subscribe(response => {
      this.can_view_postals = response[0];
      this.can_send_email = response[1];
      this.setItems();
    }));*/
  }

  sendMail() {
    
    this.showMailView = true;
  }

  onSubmit() { }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }, {
        label: 'Etiketter (csv)',
        icon: 'fa fa-id-card',
        command: () => this.createLabels(),
        visible: this.selectedmembers.length > 0 && this.can_view_postals
      }, {
        label: 'Etiketter',
        icon: 'fa fa-id-card',
        command: () => this.createLabelsHTML(),
        visible: this.selectedmembers.length > 0 && this.can_view_postals
      }, {
        label: 'Epost',
        icon: 'fa fa-envelope',
        command: () => this.sendMail(),
        visible: this.selectedmembers.length > 0 && this.can_send_email
      }];
  }

  search() {
    this.selectedmembers = [];
    const membershipinstitutions: number[] = [];
    this.membershipselectedinstitutions.forEach(i => {
      membershipinstitutions.push(i.id);
    });
    const nomembershipinstitutions: number[] = [];
    this.nomembershipselectedinstitutions.forEach(i => {
      nomembershipinstitutions.push(i.id);
    });
    this.memberform.get('membershipInstitutions').patchValue(membershipinstitutions);
    this.memberform.get('noMembershipInstitutions').patchValue(nomembershipinstitutions);
    const yrs = [];
    if (this.memberform.get('selectedYears').value) {
      this.memberform.get('selectedYears').value.forEach(x => {
        if (x) {
          yrs.push(x.year);
        }
      });
    }
    this.memberform.patchValue({ selectedYears: yrs });
    this.showSpinner = true;
    this.reportService.getMemberReportAsync(this.memberform.value as any).subscribe(response => {
      this.memberresult = response.item2;
      if (response.item1 == '') {

        this.memberPhoto = this.memberresult[0].photo;
        let lastmemberid;
        this.memberresult.forEach(mr => {
          mr['checked'] = false;

          if (mr.memberInfo.id !== lastmemberid) {
            mr['checkbox'] = true;
            lastmemberid = mr.memberInfo.id;
          }
        });
        this.showSpinner = false;
        this.setItems();
      } else {
        this.messageService.add({ severity: 'warn', summary: 'Information', detail: response.item1 });
        this.showSpinner = false;
      }
    });
  }

  checkuncheckAll(element) {
    let value = false;
    element.checked ? value = true : value = false;
    for (const m of this.memberresult) {
      m.checked = value;
      this.add(m, element);
    }
  }

  getOfficesTypes() {
    this.memberofficeService.GetOfficesTypes().subscribe(response => {
      this.officetypelist = response;
    });
  }

  setYears(evt) {
    const years: any[] = [];
    evt?.value.forEach(y => {
      years.push(y.year);
    });
    this.selectedyears = years;
    this.memberform.get('selectedYears').patchValue(years);
  }

  getOffices() {
    this.memberofficeService.GetOffices().subscribe(response => {
      this.officelist = response;
    });
  }

  clearSelectedYears() {
    this.memberform.patchValue({ selectedYears: [] });
  }

  getCommittees() {
    this.memberofficeService.Committees().subscribe(response => {
      this.committeelist = response;
    });
  }

  getAllDistricts() {
    this.memberService.getAllDistricts(0).subscribe(response => {
      this.districtlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
    });
  }

  updateInstitutionList(event: any) {
    this.institutionService.GetInstitutionChildren(Number(event.target.value)).subscribe(response => {
      this.institutionbydistrictlist = response;
    });
  }

  getAllInstitutions() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
    });
  }

  getSignTypes() {
    this.memberService.getSignTypes().subscribe(response => {
      this.signtypelist = response;
    });
  }

  getSigns() {
    this.memberService.getSigns().subscribe(response => {
      if (response) {
        this.signlist = response;
      }
    });
  }

  clear() {
    this.memberform?.reset();
    this.memberform.get('email1Exists').setValue('both');
    this.memberform.get('email2Exists').setValue('both');
    this.memberform.get('isSoftSubscriber').setValue('both');
    this.memberform.get('onlyActiveMembers').setValue(true);
    this.memberform.get('includePhoto').setValue(true);
    this.membershipselectedinstitutions = [];
    this.nomembershipselectedinstitutions = [];
    this.memberform.patchValue({ membershipInstitutions: [] });
    this.memberform.patchValue({ noMembershipInstitutions: [] });
    this.memberresult = [];
    
    this.ngOnInit();
  }


  sortData(sort: Sort) {
    const data = this.memberresult.slice();
    if (!sort.active || sort.direction === '') {
      this.memberresult = data;
      return;
    }
    this.memberresult = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.memberInfo.id, b.memberInfo.id, isAsc);
        case 'givenName': return this.compare(a.memberInfo.givenName, b.memberInfo.givenName, isAsc);
        case 'familyName': return this.compare(a.memberInfo.familyName, b.memberInfo.familyName, isAsc);
        case 'homeCity': return this.compare(a.memberInfo.h_City, b.memberInfo.h_City, isAsc);
        case 'birthday': return this.compare(a.memberInfo.birthday, b.memberInfo.birthday, isAsc);
        case 'email': return this.compare(a.memberInfo.email1, b.memberInfo.email1, isAsc);
        case 'institutionName': return this.compare(a.institutionName, b.institutionName, isAsc);
        case 'membershipStartDate': return this.compare(a.membershipStartDate, b.membershipStartDate, isAsc);
        case 'isSubscriber': return this.compare(a.memberInfo.isSubscriber, b.memberInfo.isSubscriber, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date | boolean, b: number | string | Date | boolean, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  createLabels() {
    let idlista: any[] = [];
    this.memberresult.forEach(x => {
      idlista.push(x.memberInfo.id);
    });
    this.memberService.GetMemberInfoFromMemberIds(idlista).subscribe(x => {
      if (x) {

        let memberlista: any[] = [];
        x.forEach(i => {
          const data = {
            givenName: i.givenName + ' ' + i.familyName,
            careOf: i.careOf,
            street: i.street,
            zipCode: i.zipCode,
            homeCity: i.homeCity,
            homeCountry: i.homeCountry
          };
          memberlista.push(data);
        });
        const firstrow = 'Namn;C/O;Gatuadress;Postnummer;Ort;Land';
        const filnamn = 'OF_Etikettdata_medlemmar';
        CSVDataService.exportToCsv(filnamn + '.csv', memberlista, firstrow);
      }
    });
  }

 /* createLabelsHTML() {
    console.log('valda medlemmar: ', this.selectedmembers);
    this.showLabelsAsHtml = true;
  }*/

  createLabelsHTML() {
    //this.showLabelsAsHtml = true;
    // Här ska anrop ske till InstitutionService.GetInstitutionLabelMatrix(int instid)
    /*const params = {
      InstitutionIds: this.selectedinstitutions
    };*/
    const ids = [];

    ids.push(...this.selectedmembers.map(member => member.id));

    const params = {
      Format: 'A4',
      ExportOptions: 'pdf',
      memberIds: ids
    };
    
    this.memberService.CreateMemberLabelMatrixReportForDownload(params).subscribe(response => {
      if (response) {
        let linkSource = 'data:application/pdf;base64,' + response.fileContents;
        const downloadLink = document.createElement("a");
        const fileName = 'Medlemmar_Etiketter';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  exportToCSV() {
    let exportdata = [];
    this.memberresult.forEach(data => {
      data.membershipStartDate = this.datePipe.transform(data.membershipStartDate, 'yyyy-MM-dd');
      data.membershipEndDate = this.datePipe.transform(data.membershipEndDate, 'yyyy-MM-dd');
      if (data.membershipEndDate.startsWith('9999')) {
        data.membershipEndDate = null;
      }
      data.memberInfo.birthday = this.datePipe.transform(data.memberInfo.birthday, 'yyyy-MM-dd');
      data.memberInfo.initiationDate = this.datePipe.transform(data.memberInfo.initiationDate, 'yyyy-MM-dd');
      let rowdata = {
        id: data.memberInfo.id,
        givenName: data.memberInfo.givenName,
        otherForeNamoes: data.memberInfo.otherForeNames,
        middleName: data.memberInfo.middleName,
        familyName: data.memberInfo.familyName,
        formerName: data.memberInfo.formerName,
        title: data.memberInfo.title,
        h_careOf: data.memberInfo.h_CareOf,
        h_ctreet: data.memberInfo.h_Street,
        h_zipCode: data.memberInfo.h_ZipCode,
        h_city: data.memberInfo.h_City,
        h_country: data.memberInfo.h_Country,
        w_careOf: data.memberInfo.w_CareOf,
        w_street: data.memberInfo.w_Street,
        w_zipCode: data.memberInfo.w_ZipCode,
        w_city: data.memberInfo.w_City,
        w_country: data.memberInfo.w_Country,
        o_careOf: data.memberInfo.w_CareOf,
        o_street: data.memberInfo.w_Street,
        o_zipCode: data.memberInfo.w_ZipCode,
        o_city: data.memberInfo.w_City,
        o_country: data.memberInfo.w_Country,
        phone: data.memberInfo.phone ? data.memberInfo.phone + String.fromCharCode(8203) : '',
        phone2: data.memberInfo.phone2 ? data.memberInfo.phone2 + String.fromCharCode(8203) : '',
        phoneWork: data.memberInfo.phoneWork ? data.memberInfo.phoneWork + String.fromCharCode(8203) : '',
        phoneMobile: data.memberInfo.phoneMobile ? data.memberInfo.phoneMobile + String.fromCharCode(8203) : '',
        fax: data.memberInfo.fax ? data.memberInfo.fax + String.fromCharCode(8203) : '',
        epost1: data.memberInfo.email1,
        epost2: data.memberInfo.email2,
        webSite: data.memberInfo.webSite,
        initiationDate: data.memberInfo.initiationDate,
        mentorId: data.memberInfo.mentor?.memberId,
        mentor: data.memberInfo.mentor?.givenName + ' ' + data.memberInfo.mentor?.familyName,
        birthday: data.memberInfo.birthday,
        isSubscriber: data.memberInfo.isSubscriber,
        localId: data.memberInfo.localId,
        primaryInstitution: data.primaryInstitution2?.shortName + ' ' + data.primaryInstitution2?.name,
        intitutionShortName: data.institutionShortName,
        institutionName: data.institutionName,
        institutionVisitingCity: data.institutionVisitingCity,
        institutionVisitingCountry: data.institutionVisitingCountry,
        membershipStartDate: data.membershipStartDate,
        membershipEndDate: data.membershipEndDate,
        startCause: data.startCause,
        endCause: data.endCause
      }
      exportdata.push(rowdata);
    });

    // tslint:disable-next-line:max-line-length
    const firstrow = "Medlemsnummer;Förnamn;Övriga Förnamn;Mellannamn;Efternamn;Tidigare Efternamn;Yrke/Titel;Bostad C/O;Bostad Gata/Box;Bostad Postnummer;Bostad Ort;Bostad Land;Arbete C/O;Arbete Gata/Box;Arbete Postnummer;Arbete Ort;Arbete Land;Annan C/O;Annan Gata/Box;Annan Postnummer;Annan Ort;Annan Land;Telefon 1;Telefon 2;Arbetstelefon;Mobiltelefon;Fax;E-post 1;E-post 2;Hemsida;Invigd datum;Medlemsnummer Fadder;Fadder;Födelsedatum;SOFT - (J/N);Lokalt medlemsnummer;Primärinstitution;Institution.Förkortning;Institution.Namn;Institution.Ort;Institution.Land;Fr o m;T o m;Införande anledning;Upphörande anledning";
    const datum = this.datePipe.transform(new Date(), 'yyMMdd');
    const filnamn = 'Medlemmar_' + datum;
    CSVDataService.exportToCsv(filnamn + '.csv', exportdata, firstrow);
  }

  setSelectedInstitutions(evt, institutionlist) {
    switch (institutionlist) {
      case 'membership': this.membershipselectedinstitutions = evt;
        const insts = [];
        evt.forEach(x => {
          if (x) {
            insts.push(x.id);
          }
        });
        this.memberform.patchValue({ membershipInstitutions: insts });
        break;
    }
  }

  setSelectedNoInstitutions(evt, institutionlist) {
    switch (institutionlist) {
      case 'nomembership': this.nomembershipselectedinstitutions = evt;
        const insts = [];
        evt.forEach(x => {
          if (x) {
            insts.push(x.id);
          }
        });
        this.memberform.patchValue({ noMembershipInstitutions: insts });
        break;
    }
  }

  removeMembershipSelectedInstitution(id: number) {
    const idx = this.membershipselectedinstitutions.findIndex(x => x.id === id);
    this.membershipselectedinstitutions.splice(idx, 1);
    const insts = [];
    this.membershipselectedinstitutions.forEach(x => {
      if (x) {
        insts.push(x.id);
      }
    });
    this.memberform.patchValue({ membershipInstitutions: insts });
  }

  removeNoMembershipSelectedInstitution(id: number) {
    const idx = this.nomembershipselectedinstitutions.findIndex(x => x.id === id);
    this.nomembershipselectedinstitutions.splice(idx, 1);
    const insts = [];
    this.nomembershipselectedinstitutions.forEach(x => {
      if (x) {
        insts.push(x.id);
      }
    });
    this.memberform.patchValue({ noMembershipInstitutions: insts });
  }

  setDate(first, second) {
    const datum = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.memberform.get(first).patchValue(datum);
    this.memberform.get(second).patchValue(datum);
  }

  checkMember(memberid: number) {
    return this.selectedmembers.find(item => item.id === memberid);
  }

  add(member, element) {
    if (element.checked) {
      if (!this.checkMember(member.id)) {
        this.selectedmembers.push(member);
        const idx = this.memberresult.findIndex(m => m.memberInfo.id === Number(member.id));
        this.memberresult[idx].checked = true;
      }
    } else {
      this.removeFromArray(member.id);
    }
    this.setItems();
  }

  removeFromArray(id: number) {
    const idx = this.selectedmembers.findIndex(item => item.id === id);
    this.selectedmembers.splice(idx, 1);
    const index = this.memberresult.findIndex(m => m.memberInfo.id === id);
    if (index !== -1) {
      this.memberresult[index].checked = false;
    }
  }

  closeEmail(evt: any) {
    this.showMailView = false;
    this.setItems();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => {
      x.unsubscribe();
    })
  }
}
